import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgShrink = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", {
		d: "M9 9V4.5M9 9H4.5M9 9L3.75 3.75M9 15V19.5M9 15H4.5M9 15L3.75 20.25M15 9H19.5M15 9V4.5M15 9L20.25 3.75M15 15H19.5M15 15V19.5M15 15L20.25 20.25",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}) })
});
export default SvgShrink;
